(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.obkReady) return;
    root.dataset.obkReady = '1';

    var dataEl = root.querySelector('[data-obk-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var cfg = data.config || {};
    function toNum(v) {
      if (v === null || v === undefined || v === '') return null;
      var n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
      return isFinite(n) && n > 0 ? n : (n === 0 ? 0 : null);
    }
    function toBool(v) {
      if (v === true || v === 'true') return true;
      if (v === false || v === 'false') return false;
      return null;
    }
    function norm(p) {
      p.diameter = toNum(p.diameter);
      p.height = toNum(p.height);
      p.plants = toNum(p.plants);
      p.led = toBool(p.led);
      p.batteries = toBool(p.batteries);
      p.price = parseInt(p.price, 10) || 0;
      p.images = (p.images || []).filter(function (i) { return i && i.src; });
      p.plantList = (p.plantList || []).filter(Boolean);
      if (p.led === true && p.batteries === false) p.ledNote = cfg.batteryNote || 'Batterien (2× AAA) nicht enthalten';
      return p;
    }
    var glasses = (data.glasses || []).filter(function (p) { return p && p.variantId; }).map(norm);
    var sets = (data.sets || []).filter(function (p) { return p && p.variantId; }).map(norm);
    // Basis-Set (0 Pflanzen) ans Ende, sonst Reihenfolge der Kollektion
    sets.sort(function (a, b) { return (a.plants === 0 ? 1 : 0) - (b.plants === 0 ? 1 : 0); });

    var state = { glass: null, set: null, photo: 0 };
    var fmt;
    try {
      fmt = new Intl.NumberFormat(cfg.locale || 'de-DE', { style: 'currency', currency: cfg.currency || 'EUR' });
    } catch (e) {
      fmt = { format: function (v) { return v.toFixed(2).replace('.', ',') + ' €'; } };
    }
    function money(cents) { return fmt.format((cents || 0) / 100); }
    function num(n) { return String(n).replace('.', ','); }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function byId(list, id) { for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i]; return null; }
    function q(sel) { return root.querySelector(sel); }
    function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var ICON_CHECK = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M2.5 7.4 5.6 10.4 11.5 3.6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    /* ---------- Passungslogik ---------- */
    // Sets sind für 20–30 cm Ø ausgelegt. Fehlen Daten → null (neutral).
    function setKind(set) {
      if (typeof set.plants !== 'number') return null;
      if (set.plants === 0) return 'basis';
      if (set.plants >= 5) return 'five';
      return 'three';
    }
    function glassSize(glass) {
      if (!glass || typeof glass.diameter !== 'number') return null;
      if (glass.diameter < 20) return 'small';
      if (glass.diameter > 30) return 'large';
      return 'standard';
    }
    // Liefert {level:'rec'|'ok'|'weak', text} für ein Set im Kontext des gewählten Glases
    function fitFor(set, glass) {
      var size = glassSize(glass), kind = setKind(set);
      if (!size || !kind) return null;
      var d = num(glass.diameter);
      if (size === 'small') {
        if (kind === 'basis') return { level: 'rec', text: 'Ideal für Ø ' + d + ' cm: reicht großzügig, Rest zum Nachfüllen' };
        if (kind === 'three') return { level: 'ok', text: 'Reicht für Ø ' + d + ' cm großzügig – Rest für ein zweites Glas' };
        return { level: 'weak', text: 'Für Ø ' + d + ' cm eher zu viel – ein 3er-Set reicht' };
      }
      if (size === 'large') {
        if (kind === 'five') return { level: 'rec', text: 'Empfohlen: füllt Ø ' + d + ' cm schön dicht' };
        if (kind === 'three') return { level: 'weak', text: 'Wirkt in Ø ' + d + ' cm eher licht – 5er-Set empfohlen' };
        return { level: 'weak', text: 'Ausgelegt für 20–30 cm Ø – für dieses Glas evtl. knapp' };
      }
      if (kind === 'basis') return { level: 'ok', text: 'Passt zu ' + glass.title + ' – Pflanzen bringst du selbst mit' };
      return { level: 'ok', text: 'Passt zu ' + glass.title + ' (Ø ' + d + ' cm)' };
    }
    function glassNote(glass) {
      var size = glassSize(glass);
      if (size === 'small') return cfg.noteSmall || '';
      if (size === 'large') return cfg.noteLarge || '';
      return '';
    }

    /* ---------- Rendering ---------- */
    function imgTag(img, sizes, alt, eager) {
      if (!img || !img.src) return '';
      return '<img src="' + esc(img.src) + '"' +
        (img.srcset ? ' srcset="' + esc(img.srcset) + '" sizes="' + esc(sizes) + '"' : '') +
        ' alt="' + esc(alt) + '" width="' + (img.w || 800) + '" height="' + (img.h || 1000) + '"' +
        (eager ? '' : ' loading="lazy"') + ' decoding="async">';
    }

    function glassCard(g, i) {
      var meta = [];
      if (typeof g.diameter === 'number') meta.push('Ø ' + num(g.diameter) + ' cm');
      if (typeof g.height === 'number') meta.push(num(g.height) + ' cm hoch');
      var badges = '';
      if (g.led === true) badges += '<span class="obk-badge obk-badge--led">' + esc(cfg.ledLabel || 'LED-Korken') + '</span>';
      return '<li role="none"><button type="button" role="radio" class="obk-card" data-kind="glass" data-id="' + esc(g.id) + '"' +
        ' aria-checked="false" tabindex="' + (i === 0 ? '0' : '-1') + '"' +
        (g.available ? '' : ' aria-disabled="true"') +
        ' aria-describedby="obk-g-' + esc(g.id) + '-d">' +
        '<span class="obk-card__media">' + imgTag(g.images[0], '(min-width: 990px) 22vw, 50vw', '', i < 4) +
          '<span class="obk-card__check">' + ICON_CHECK + '</span>' +
          '<span class="obk-badges">' + badges + '</span></span>' +
        '<span class="obk-card__body">' +
          '<span class="obk-card__row"><span class="obk-card__name">' + esc(g.title) + '</span>' +
          '<span class="obk-card__price">' + money(g.price) + '</span></span>' +
          '<span class="obk-card__meta" id="obk-g-' + esc(g.id) + '-d">' + esc(meta.join(', ')) +
            (g.ledNote ? '<br>' + esc(g.ledNote) : '') +
            (g.available ? '' : '<br><span class="obk-card__soldout">' + esc(cfg.soldOut || 'Gerade ausverkauft') + '</span>') +
          '</span>' +
        '</span></button></li>';
    }

    function setName(s) { return s.plants === 0 ? (cfg.basisTitle || s.title) : s.title; }
    function setMeta(s) {
      if (s.plants === 0) return cfg.basisMeta || 'Für deine eigenen Pflanzen';
      if (typeof s.plants === 'number') return s.plants + ' Pflanzen';
      return '';
    }

    function setCard(s, i) {
      var plantList = (s.plantList && s.plantList.length)
        ? '<ul class="obk-card__plants">' + s.plantList.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ul>'
        : '';
      return '<li role="none"><button type="button" role="radio" class="obk-card" data-kind="set" data-id="' + esc(s.id) + '"' +
        ' aria-checked="false" tabindex="' + (i === 0 ? '0' : '-1') + '"' +
        (s.available ? '' : ' aria-disabled="true"') +
        ' aria-describedby="obk-s-' + esc(s.id) + '-d obk-s-' + esc(s.id) + '-f">' +
        '<span class="obk-card__media">' + imgTag(s.images[0], '(min-width: 1200px) 18vw, (min-width: 560px) 45vw, 92vw', '', false) +
          '<span class="obk-card__check">' + ICON_CHECK + '</span>' +
          '<span class="obk-badges"><span class="obk-badge obk-badge--rec" hidden>' + esc(cfg.recLabel || 'Empfohlen') + '</span></span></span>' +
        '<span class="obk-card__body">' +
          '<span class="obk-card__row"><span class="obk-card__name">' + esc(setName(s)) + '</span>' +
          '<span class="obk-card__price">' + money(s.price) + '</span></span>' +
          '<span class="obk-card__meta" id="obk-s-' + esc(s.id) + '-d">' + esc(setMeta(s)) +
            (s.available ? '' : '<br><span class="obk-card__soldout">' + esc(cfg.soldOut || 'Gerade ausverkauft') + '</span>') +
          '</span>' + plantList +
          '<span class="obk-card__fit" id="obk-s-' + esc(s.id) + '-f"></span>' +
        '</span></button></li>';
    }

    var glassList = q('[data-obk-glasses]');
    var setList = q('[data-obk-sets]');
    glassList.innerHTML = glasses.map(glassCard).join('');
    setList.innerHTML = sets.map(setCard).join('');
    if (!glasses.length) glassList.outerHTML = '<p class="obk-step__text">' + esc(cfg.emptyGlasses || '') + '</p>';
    if (!sets.length) setList.outerHTML = '<p class="obk-step__text">' + esc(cfg.emptySets || '') + '</p>';

    /* ---------- Radiogroup-Tastatur ---------- */
    function setupGroup(group) {
      if (!group) return;
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.obk-card');
        if (!btn || !group.contains(btn)) return;
        choose(btn);
      });
      group.addEventListener('keydown', function (e) {
        var btn = e.target.closest('.obk-card');
        if (!btn) return;
        var keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
        if (keys.indexOf(e.key) === -1) {
          if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); choose(btn); }
          return;
        }
        e.preventDefault();
        var items = Array.prototype.slice.call(group.querySelectorAll('.obk-card')).filter(function (b) { return b.getAttribute('aria-disabled') !== 'true'; });
        if (!items.length) return;
        var idx = items.indexOf(btn), next;
        if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = items.length - 1;
        else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (idx + 1) % items.length;
        else next = (idx - 1 + items.length) % items.length;
        items[next].focus();
        choose(items[next]);
      });
    }
    function rove(group, active) {
      Array.prototype.forEach.call(group.querySelectorAll('.obk-card'), function (b) {
        b.setAttribute('tabindex', b === active ? '0' : '-1');
      });
    }
    // Startfokus auf erstes verfügbares Element
    [glassList, setList].forEach(function (g) {
      if (!g || !g.querySelector) return;
      var first = g.querySelector('.obk-card:not([aria-disabled="true"])');
      if (first) rove(g, first);
    });

    function choose(btn) {
      var group = btn.closest('[role="radiogroup"]');
      if (btn.getAttribute('aria-disabled') === 'true') {
        announce((cfg.soldOutAnnounce || 'Gerade ausverkauft, bitte wähle eine andere Option.'));
        return;
      }
      Array.prototype.forEach.call(group.querySelectorAll('.obk-card'), function (b) {
        b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
      });
      rove(group, btn);
      var kind = btn.dataset.kind;
      if (kind === 'glass') { state.glass = byId(glasses, btn.dataset.id); state.photo = 0; }
      else { state.set = byId(sets, btn.dataset.id); }
      update();
    }
    setupGroup(glassList);
    setupGroup(setList);

    /* ---------- Live-Region ---------- */
    var live = q('[data-obk-live]');
    function announce(msg) { if (!live) return; live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); }

    /* ---------- Vorschau ---------- */
    var stageMain = q('[data-obk-stage-main]');
    var stageInset = q('[data-obk-stage-inset]');
    var stageEmpty = q('[data-obk-stage-empty]');
    var thumbs = q('[data-obk-thumbs]');

    function photos() {
      var list = [];
      if (state.glass) state.glass.images.slice(0, 2).forEach(function (img) { if (img) list.push({ img: img, label: state.glass.title }); });
      if (state.set && state.set.images[0]) list.push({ img: state.set.images[0], label: setName(state.set) });
      if (state.set && state.set.images[1]) list.push({ img: state.set.images[1], label: setName(state.set) });
      return list;
    }
    function renderStage() {
      var list = photos();
      if (!list.length) {
        stageMain.hidden = true; stageInset.hidden = true; stageEmpty.hidden = false; thumbs.hidden = true; return;
      }
      stageEmpty.hidden = true;
      if (state.photo >= list.length) state.photo = 0;
      var cur = list[state.photo];
      stageMain.hidden = false;
      stageMain.src = cur.img.src;
      if (cur.img.srcset) { stageMain.srcset = cur.img.srcset; stageMain.sizes = '(min-width: 990px) 46rem, 100vw'; } else { stageMain.removeAttribute('srcset'); }
      stageMain.alt = cur.label;
      // Set als runde Einblendung, solange das Glas groß gezeigt wird
      var showInset = state.set && state.glass && state.photo < Math.min(2, state.glass.images.filter(Boolean).length);
      stageInset.hidden = !showInset;
      if (showInset) {
        var si = stageInset.querySelector('img');
        si.src = state.set.images[0].src;
        si.alt = setName(state.set);
      }
      thumbs.hidden = list.length < 2;
      thumbs.innerHTML = list.map(function (p, i) {
        return '<button type="button" class="obk-thumb" data-photo="' + i + '" aria-pressed="' + (i === state.photo) + '" aria-label="' + esc((cfg.photoLabel || 'Bild') + ' ' + (i + 1) + ': ' + p.label) + '">' +
          '<img src="' + esc(p.img.thumb || p.img.src) + '" alt="" width="112" height="112" loading="lazy"></button>';
      }).join('');
    }
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('.obk-thumb');
      if (!b) return;
      state.photo = parseInt(b.dataset.photo, 10) || 0;
      renderStage();
      var again = thumbs.querySelector('[data-photo="' + state.photo + '"]');
      if (again) again.focus();
    });

    /* ---------- Zusammenfassung ---------- */
    var lineGlass = q('[data-obk-line-glass]');
    var lineSet = q('[data-obk-line-set]');
    var priceGlass = q('[data-obk-price-glass]');
    var priceSet = q('[data-obk-price-set]');
    var totalEls = qa('[data-obk-total]');
    var ctas = qa('[data-obk-cta]');
    var note = q('[data-obk-note]');
    var noteText = q('[data-obk-note-text]');
    var stepGlass = q('[data-obk-step="glass"]');
    var stepSet = q('[data-obk-step="set"]');
    var status = q('[data-obk-status]');
    var barPics = q('[data-obk-bar-pics]');

    function update() {
      // Set-Karten: Passung
      qa('.obk-card[data-kind="set"]').forEach(function (btn) {
        var s = byId(sets, btn.dataset.id);
        var fit = state.glass ? fitFor(s, state.glass) : null;
        var fitEl = btn.querySelector('.obk-card__fit');
        var rec = btn.querySelector('.obk-badge--rec');
        fitEl.textContent = fit ? fit.text : '';
        fitEl.classList.toggle('is-weak', !!fit && fit.level === 'weak');
        if (rec) rec.hidden = !(fit && fit.level === 'rec');
      });
      var n = state.glass ? glassNote(state.glass) : '';
      note.hidden = !n;
      noteText.textContent = n;

      // Zeilen
      if (state.glass) {
        lineGlass.textContent = state.glass.title; lineGlass.classList.remove('is-empty');
        priceGlass.textContent = money(state.glass.price);
      } else {
        lineGlass.textContent = cfg.pickGlass || 'Noch nicht gewählt'; lineGlass.classList.add('is-empty'); priceGlass.textContent = '';
      }
      if (state.set) {
        lineSet.textContent = setName(state.set); lineSet.classList.remove('is-empty');
        priceSet.textContent = money(state.set.price);
      } else {
        lineSet.textContent = cfg.pickSet || 'Noch nicht gewählt'; lineSet.classList.add('is-empty'); priceSet.textContent = '';
      }
      var total = (state.glass ? state.glass.price : 0) + (state.set ? state.set.price : 0);
      totalEls.forEach(function (el) { el.textContent = total ? money(total) : '–'; });
      if (barPics) {
        barPics.innerHTML = [state.glass, state.set].filter(Boolean).map(function (p) {
          var i = p.images[0];
          return i ? '<img src="' + esc(i.thumb || i.src) + '" alt="" width="80" height="80">' : '';
        }).join('');
        barPics.hidden = !barPics.innerHTML;
      }
      stepGlass.classList.toggle('is-done', !!state.glass);
      stepSet.classList.toggle('is-done', !!state.set);

      // CTA-Logik: führt zum nächsten fehlenden Schritt, sonst Warenkorb
      var mode = !state.glass ? 'glass' : (!state.set ? 'set' : 'add');
      ctas.forEach(function (b) {
        b.dataset.mode = mode;
        var label = mode === 'glass' ? (cfg.ctaGlass || 'Glas wählen') : mode === 'set' ? (cfg.ctaSet || 'Pflanzenset wählen') : (cfg.ctaAdd || 'Flaschengarten in den Warenkorb');
        if (mode === 'add' && b.hasAttribute('data-obk-cta-short')) label = cfg.ctaShort || 'In den Warenkorb';
        if (mode !== 'add' && b.hasAttribute('data-obk-cta-short')) label = mode === 'glass' ? (cfg.ctaGlassShort || 'Glas wählen') : (cfg.ctaSetShort || 'Set wählen');
        b.querySelector('[data-obk-cta-label]').textContent = label;
        b.classList.toggle('is-secondary', mode !== 'add');
      });
      if (status && !status.classList.contains('is-error')) status.textContent = '';
      renderStage();
    }

    function scrollToStep(step) {
      if (!step) return;
      step.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      var target = step.querySelector('.obk-card[tabindex="0"]');
      if (target) setTimeout(function () { target.focus({ preventScroll: true }); }, reduceMotion ? 0 : 400);
    }

    ctas.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.mode === 'glass') return scrollToStep(stepGlass);
        if (b.dataset.mode === 'set') return scrollToStep(stepSet);
        addToCart(b);
      });
    });

    function setBusy(busy) {
      ctas.forEach(function (b) {
        b.setAttribute('aria-busy', busy ? 'true' : 'false');
        b.disabled = !!busy;
        if (busy) b.querySelector('[data-obk-cta-label]').textContent = cfg.ctaBusy || 'Wird hinzugefügt …';
      });
    }
    function showStatus(msg, type, html) {
      if (!status) return;
      status.classList.toggle('is-error', type === 'error');
      status.classList.toggle('is-ok', type === 'ok');
      if (html) status.innerHTML = msg; else status.textContent = msg;
    }

    function addToCart() {
      if (!state.glass || !state.set) return;
      var pairId = 'K' + Date.now().toString(36).toUpperCase();
      var props = { _Konfigurator: 'Flaschengarten', '_Konfigurator-ID': pairId };
      var items = [
        { id: state.glass.variantId, quantity: 1, properties: props },
        { id: state.set.variantId, quantity: 1, properties: props }
      ];
      showStatus('', null);
      setBusy(true);

      var drawer = document.querySelector('cart-drawer');
      var useDrawer = !!(drawer && typeof drawer.renderContents === 'function');
      var body = { items: items };
      if (useDrawer) {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }
      var routes = window.routes || {};
      var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
      var cartUrl = routes.cart_url || '/cart';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) {
            var d = (res.json && (res.json.description || res.json.message)) || '';
            throw new Error(d);
          }
          if (useDrawer && res.json.sections) {
            try {
              drawer.renderContents({ id: res.json.items && res.json.items[0] && res.json.items[0].id, sections: res.json.sections });
              setBusy(false); update();
              showStatus(cfg.addedText || 'Im Warenkorb.', 'ok');
              return;
            } catch (e) { /* Fallback unten */ }
          }
          showStatus(cfg.addedRedirect || 'Im Warenkorb. Du wirst weitergeleitet …', 'ok');
          window.location.href = cartUrl;
        })
        .catch(function (err) {
          setBusy(false); update();
          var base = cfg.errorText || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
          var msg = (err && err.message ? err.message + ' ' : '') + base;
          showStatus(esc(msg) + ' <a href="' + esc(cartUrl) + '">' + esc(cfg.toCart || 'Zum Warenkorb') + '</a>', 'error', true);
        });
    }

    /* ---------- Mobile Leiste ausblenden, wenn Zusammenfassung sichtbar ---------- */
    var bar = q('[data-obk-bar]');
    var summary = q('[data-obk-summary]');
    if (bar && summary && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-hidden', en.isIntersecting); if (en.isIntersecting) bar.setAttribute('inert', ''); else bar.removeAttribute('inert'); });
      }, { threshold: 0.35 }).observe(summary);
    }

    update();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-obk-root]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-obk-root]');
    if (r) init(r);
  });
})();
